<div class="error-box">
    <div class="error-body text-center">
        <h1 class="error-title text-danger">404</h1>
        <h3 class="text-uppercase error-subtitle">PÁGINA NO ENCONTRADA</h3>
        <p class="text-muted mt-4 mb-4">
            PARECE QUE LA PÁGINA QUE ESTÁS BUSCANDO NO EXISTE
        </p>
    </div>
</div>